<template>
  <div v-if="hasPublicationDetails">
    <h2 class="text-h6 font-weight-bold text-secondary mt-10 mb-2">
      Publication Details
    </h2>

    <DataTable
      :headers="tableHeaders"
      :items="publicationDetailsData"
      textAlign="text-left"
      classes="mb-12"
      :skillName="false"
      setFontSize="14px"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import DataTable from '../shared/DataTable.vue';

  interface Props {
    report?: any;
    gradeReport?: any;
  }

  const props = defineProps<Props>();

  const hasPublicationDetails = computed(() => {
    const details = props.gradeReport?.details || props.report?.details;

    if (!details || !Array.isArray(details) || details.length === 0) {
      return false;
    }

    return details.some((detail: any) => {
      return (
        detail.title ||
        detail.isbn ||
        detail.edition ||
        detail.publisher ||
        detail.copyright ||
        detail.year
      );
    });
  });

  const publicationDetailsData = computed(() => {
    const details = props.gradeReport?.details || props.report?.details;

    if (!details || !Array.isArray(details) || details.length === 0) {
      return [];
    }

    return details.map((detail: any) => ({
      Title: detail.title || detail.name || '',
      ISBN: detail.isbn || '',
      Edition: detail.edition || '',
      Publisher: detail.publisher?.name || detail.publisher || '',
      Year: detail.copyright || detail.year || '',
    }));
  });

  const tableHeaders = ['Title', 'ISBN', 'Edition', 'Publisher', 'Year'];
</script>

<style lang="scss" scoped></style>
